import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/expert.png';
import _imports_1 from '@/assets/images/index/icon-question.png';
import _imports_2 from '@/assets/images/index/icon-doctor.png';
import _imports_3 from '@/assets/images/index/icon-inject.png';
import _imports_4 from '@/assets/images/index/icon-doc.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1fd5e47a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "nav"
};
var _hoisted_2 = {
  "class": "left-content"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "专家答疑", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h5", null, "三甲名医在线", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "expert-img",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_6 = [_hoisted_3, _hoisted_4, _hoisted_5];
var _hoisted_7 = {
  "class": "left-item"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "大家都在问", -1);
});
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  "class": "right-content"
};
var _hoisted_11 = {
  "class": "right-item test-box"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "测一测", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("我是否适合使用GLP-1"), /*#__PURE__*/_createElementVNode("span", {
    "class": "hot"
  }, "热")], -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("我可以减重多少？"), /*#__PURE__*/_createElementVNode("span", {
    "class": "hot"
  }, "热")], -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "用药指导", -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "规避用药风险", -1);
});
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "GLP-1药物", -1);
});
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "有哪些GLP-1药物", -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "临床指南", -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "权威临床诊疗参考", -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    "class": "left-item cursor-pointer",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.push('/expertAnswer');
    })
  }, _hoisted_6), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questionList, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      onClick: function onClick($event) {
        return $options.handleClick(item.title);
      },
      "class": "ellipsis",
      key: index
    }, _toDisplayString(item.title), 9, _hoisted_9);
  }), 128))])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_router_link, {
    to: "/takeTest"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_13];
    }),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/takeDiss"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  }), _hoisted_15]), _createVNode(_component_router_link, {
    "class": "right-item",
    to: "/medicationGuidance"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_16, _hoisted_17, _hoisted_18];
    }),
    _: 1
  }), _createVNode(_component_router_link, {
    "class": "right-item",
    to: "/glpMedicine"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_19, _hoisted_20, _hoisted_21];
    }),
    _: 1
  }), _createVNode(_component_router_link, {
    "class": "right-item",
    to: "/clinicalGuideline"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_22, _hoisted_23, _hoisted_24];
    }),
    _: 1
  })])]);
}